import { useContext, useMemo } from 'react'
import { ShortCodeDataContext } from './ShortCodeContextProvider'
import { ShortCodeContextProvider_cemeteryFragment$data } from './__generated__/ShortCodeContextProvider_cemeteryFragment.graphql'
import { ShortCodeContextProvider_postFragment$data } from './__generated__/ShortCodeContextProvider_postFragment.graphql'

export const useShortCodeDataCemeteries = (
  ids: number[]
): ShortCodeContextProvider_cemeteryFragment$data['items'] => {
  const { cemeteries } = useContext(ShortCodeDataContext)

  return useMemo(
    () =>
      ids.reduce<ShortCodeContextProvider_cemeteryFragment$data['items']>(
        (res, id) => {
          const cemetery = cemeteries?.[id]
          return cemetery ? [...res, cemetery] : res
        },
        []
      ),
    [cemeteries, ids]
  )
}

type Post = ShortCodeContextProvider_postFragment$data['items'][number]

export const useShortCodeDataPosts = (
  slugs: string[]
): ShortCodeContextProvider_postFragment$data['items'] => {
  const { posts } = useContext(ShortCodeDataContext)

  return useMemo(
    () =>
      slugs.map((slug) => posts?.[slug]).filter((post): post is Post => !!post),
    [posts, slugs]
  )
}
